module.exports = __webpack_public_path__ + "img/icon16.2b94fb21.png";